<label class="checkbox-text">
    {{text}}
    <input type="checkbox">
    <span class="checkbox-text_mark"></span>
</label>